import { useTable, useSortBy } from 'react-table';

/*
The useTable instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useTable.md#instance-properties
The useSortBy instance is documented here:
https://github.com/tannerlinsley/react-table/blob/master/docs/src/pages/docs/api/useSortBy.md#instance-properties
*/
const useSortTable = ({
  columns,
  data,
  defaultSortId,
  defaultSortDesc = false,
}) => {
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [{ id: defaultSortId, desc: defaultSortDesc }],
      },
    },
    useSortBy,
  );
  return { columnsLength: columns.length, ...tableInstance };
};

export default useSortTable;
